import Index from "./Index.vue";
import Show from "./Show.vue";

export default [
  {
    path: "",
    name: "UsersInquiriesIndex",
    component: Index,
    meta: {
      title: "問い合わせ管理",
      tree: [
        {
          name: "UsersManagementIndex",
          title: "管理者メニュー",
        },
      ],
    },
  },
  {
    path: ":id",
    name: "UsersInquiriesShow",
    component: Show,
    meta: {
      title: "詳細",
      tree: [
        {
          name: "UsersManagementIndex",
          title: "管理者メニュー",
        },
        { title: "問い合わせ管理", to: { name: "UsersInquiriesIndex" } },
      ],
    },
  },
];
